import landingDomainCreate from './actions/landingDomainCreate';
import landingDomainExpiresAt from './actions/landingDomainExpiresAt';
import landingDomainRemove from './actions/landingDomainRemove';
import landingDomainsList from './actions/landingDomainsList';
import getLandingDomains from './getters/getLandingDomains';
import landingDomainsUpload from './mutations/landingDomainsUpload';

const actions = {
    landingDomainCreate,
    landingDomainRemove,
    landingDomainsList,
    landingDomainExpiresAt
};

const mutations = {
    landingDomainsUpload
};

const getters = {
    getLandingDomains
};

export default { actions, mutations, getters };
